// src/components/BietGiChua.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchData } from "../services/api";
import { chuNgayAmDayDu } from "../utils/amlich";
import { veDangNgay } from "../utils/ngay";

// ============================================================
// 📢 BIẾT GÌ CHƯA? — khối tin chung trên Bảng tin (Đợt N2, thêm mẹo vặt ở N6)
// ------------------------------------------------------------
// Cái tên là của chính chủ nhà, ghi trong chân dung 4.1, kèm lý do:
// *"nó là một câu hỏi nên người đọc tự muốn xem."*
//
// ⚠️ KHỐI NÀY CHỈ ĐỌC. KHÔNG có nút thêm/sửa/xóa. Cố ý. Chỉ có đường dẫn.
//
// Trước Đợt N2, chỗ này là `FamilyCalendar` — một ô CRUD đầy đủ nằm trên
// Bảng tin. Chủ nhà 08/09/2026: *"ý tôi muốn trang Bảng tin phải thật sự
// là bảng tin… Trình bày như vậy quá nghiệp dư."*
//
// ⚠️ Sự kiện: chỉ hiện mục đã tick "Cho cả nhà biết" (`is_shared`). Máy chủ
// đã lọc theo quyền `family.view` rồi, nên người bị cắt quyền Xem sẽ nhận về
// danh sách không có mục chung nào.
//
// ============================================================
// 🎉 MẸO MỚI + LỜI KHEN (N6, 15/09/2026 — góc vui hướng A)
// ------------------------------------------------------------
// Anh (MV7): *"Làm cho 'bật' lên, khuyến khích mọi người."* Anh chọn hướng A:
// vui mà không chấm điểm. Mẹo MỚI hiện 3 ngày, tối đa 2 dòng, NẰM DƯỚI sự
// kiện lịch (Đ1) — máy chủ đã lọc sẵn (`/api/meo-vat/moi`). Sửa mẹo cũ không
// lên lại (Đ5).
//
// ⚠️ Lời khen là "Cảm ơn Mẹ!" — KHÔNG "Mẹ đã góp 5 mẹo", KHÔNG "góp nhiều
// nhất tuần". Con số và so sánh là thứ chân dung 5.4 đã đóng; muốn thêm thì
// xem mục "Góc vui nâng cao" trong lộ trình, bàn với anh trước.
// ============================================================

const SO_MUC_HIEN = 3;

const homNay = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

const veNgayNgan = (chuoi) =>
  new Date(chuoi).toLocaleDateString("vi-VN", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
  });

function BietGiChua() {
  const [ds, setDs] = useState([]);
  const [meoMoi, setMeoMoi] = useState([]);
  const [dangTai, setDangTai] = useState(true);

  useEffect(() => {
    // Hai nguồn độc lập: một bên hỏng thì bên kia vẫn hiện.
    Promise.all([
      fetchData("lich")
        .then((d) => setDs(Array.isArray(d) ? d : []))
        .catch(() => setDs([])),
      fetchData("meo-vat/moi")
        .then((d) => setMeoMoi(Array.isArray(d) ? d : []))
        .catch(() => setMeoMoi([])),
    ]).finally(() => setDangTai(false));
  }, []);

  // Đang tải thì không hiện gì cả — khối này là tin phụ trên Bảng tin,
  // một dòng "đang tải" nhấp nháy rồi biến mất chỉ tổ rối mắt.
  if (dangTai) return null;

  const nay = homNay();
  const sapToi = ds
    .filter((sk) => sk.is_shared)
    .filter((sk) => new Date(veDangNgay(sk.date) + "T00:00:00") >= nay)
    .slice(0, SO_MUC_HIEN);

  // Không có gì thì ẩn hẳn, không hiện khung rỗng.
  if (sapToi.length === 0 && meoMoi.length === 0) return null;

  return (
    <div className="card bgc-khoi">
      <h3>📢 Biết gì chưa?</h3>
      {sapToi.length > 0 && (
        <ul className="list">
          {sapToi.map((sk) => (
            <li key={sk.id} className="list-item bgc-dong">
              <div>
                <strong>{sk.title}</strong>
                <div className="bgc-ngay">
                  {veNgayNgan(sk.date)}
                  <span className="ngay-am">{chuNgayAmDayDu(sk.date)}</span>
                  {sk.time && ` · ${sk.time}`}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}

      {meoMoi.map((m) => {
        const ten = m.ten_nguoi_viet || "Người nhà";
        return (
          <Link key={m.id} to={`/meo-vat/${m.id}`} className="bgc-khen">
            🎉 <strong>{ten}</strong> vừa góp mẹo <strong>“{m.tieu_de}”</strong>
            <span className="bgc-khen-phu">Cảm ơn {ten}! · bấm để xem</span>
          </Link>
        );
      })}

      {sapToi.length > 0 && (
        <Link to="/lich" className="duong-dan-phu">
          📅 Xem cả lịch nhà mình →
        </Link>
      )}
    </div>
  );
}

export default BietGiChua;
